import { AtomicOption } from '@df/ui/atomic/atomic.interface';
import range from 'lodash-es/range';

/**
 * Padding options
 */
export function getPadding(prefix: string, config) {
    let paddings = range(config.padding.min || 0, config.padding.max ? config.padding.max + 1 : 0);

    if (config.padding.custom && Array.isArray(config.padding.custom)) {
        paddings = [...paddings, ...config.padding.custom];
    }

    const padding: AtomicOption[] = [];
    paddings
        .sort((a, b) => a - b)
        .forEach((i: number) => {
            padding.push({
                key: `p-${prefix}-${i}`,
                title: `${i}`
            });
        });

    return padding;
}
